import { render } from "./TermsAndPrivacy.vue?vue&type=template&id=2ab46630&scoped=true"
const script = {}

import "./TermsAndPrivacy.vue?vue&type=style&index=0&id=2ab46630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab46630"]])

export default __exports__